module.exports = __webpack_public_path__ + "static/media/dr-shape.2ad71e97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/dr-shape.svg
// module id = 530
// module chunks = 0